import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	blockTitle: '',
	blockDesc: '',
	blockContent: {
		left: {
			gap: 'gap24', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'Повече знания, повече възможности',
					text: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		right: {
			gap: 'gap-8-12', // classname from css file (block.scss) for space between items
			content: [
				{
					title: '',
					subtitle: '',
					description: 'Имаш достъп до богата база знания с ръководства, статии и съвети. Отговори, написани от експерти – за начинаещи и напреднали.',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: '<div class="pb-5-8"><a href="https://help.superhosting.bg/" target="_blank">help.superhosting.bg</a></div>',
					subtitle: 'база от знания',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: '<div class="pb-5-8"><a href="https://blog.superhosting.bg/" target="_blank">blog.superhosting.bg</a></div>',
					subtitle: 'съвети, новини и тенденции',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		noteData: []
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockTitle: '',
	blockDesc: '',
	blockContent: {
		left: {
			gap: 'gap24', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'More knowledge, more possibilities',
					text: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		right: {
			gap: 'gap-8-12', // classname from css file (block.scss) for space between items
			content: [
				{
					title: '',
					subtitle: '',
					description: 'You have access to a rich knowledge base with guides, articles and tips. Answers written by experts for beginners and advanced users.',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: '<a href="https://help.superhosting.bg/" target="_blank">help.superhosting.bg</a>',
					subtitle: 'knowledge base',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: '<a href="https://blog.superhosting.bg/" target="_blank">blog.superhosting.bg</a>',
					subtitle: 'Tips, news and trends',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		noteData: []
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];